module.exports = __webpack_public_path__ + "assets/projects/maria-jose-moreno/slider.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/maria-jose-moreno/slider.mp4
// module id = 51
// module chunks = 0